import {Route, Routes, Navigate } from 'react-router-dom';
import {PrivateRoute} from './PrivateRoute';
import Login from '../auth/Login';
import Frame from './Frame';
import Prefetch from './Prefetch';
import Club from '../components/club/Club';
import { ClubCreate } from '../components/club/ClubCreate';
import { TeamCreate } from '../components/team/TeamCreate';
import TournamentAdmin from '../components/admin/TournamentAdmin';
import FinancialAdmin from '../components/admin/FinancialAdmin';
import MealAdmin from '../components/admin/MealAdmin';
import ContactAdmin from '../components/admin/ContactAdmin';
import ParametersAdmin from '../components/admin/ParametersAdmin';
import Admin from '../components/admin/Admin';
import Email from '../components/email/Email';
import VersionInfo from '../components/admin/VersionInfo';
import Impressum from '../components/impressum/Impressum';

// Hier erstellen wir jetzt einen Router, der bestimmte
// Daten schon einmal für die Objekte bereitstellt und diese
// dann auch nur einmal lädt
// wenn wir mit dem root pfad starten, dann gehen wir einfach
// direkt zur Registration    
// Admin stellt die Basisdaten dar - damit alle anderen auch von dem
// Titel oder dem Seitenmenü profitieren können, erstellen wir diese
// direkt in der Admin-App und markieren dort mit <outlet>, dass wir
// alle Kinderknoten darunter einfügen wollen.
const BaseRouter = () => {
  return (       
    <Routes>
      <Route path="/*" element={<PrivateRoute />} >
        <Route index element={<Prefetch />} />
        <Route path=":year/*" element={<Frame />} >                                   
          <Route path="club/add/*" element={<ClubCreate />} /> 
          <Route path=":clubLabel/:teamLabel/:teamCounter/add" element={<TeamCreate />} />
          <Route path=":clubLabel/*" element={<Club />} />    
          <Route path="admin" element={<Admin />} >
            <Route path="tournament" element={<TournamentAdmin />} />
            <Route path="parameters" element={<ParametersAdmin />} />
            <Route path="financials" element={<FinancialAdmin /> } />
            <Route path="meals" element={<MealAdmin /> } />
            <Route path="contacts" element={<ContactAdmin /> } />
            <Route path="email" element={<Email />} />
            <Route path="about" element={<VersionInfo />} />
            <Route index element={<Navigate to="tournament" replace /> } />
          </Route>
        </Route>          
      </Route>
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/login" element={<Login />} />      
    </Routes>
  );
};


export default BaseRouter;